import React from "react";
import Select from "react-select";
import { Form, Col } from "react-bootstrap";
import { useFormikContext, useField } from "formik";
import makeAnimated from "react-select/animated";
import chroma from "chroma-js";

const colourStylesMulti = {
    control: (styles) => ({
        ...styles,
        backgroundColor: "#f4f7fa !important",
        padding: "10px important",
        // border:'1px solid #1de9b6',
        minHeight: 43,
        borderRadius: 0,
        boxShadow: "none",
        outline: "none"
    }),
    placeholder: (defaultStyles) => ({ ...defaultStyles, color: "red" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(data.color);
        return {
            ...styles,
            backgroundColor: isDisabled
                ? null
                : isSelected
                ? data.color
                : isFocused
                ? color.alpha(0.1).css()
                : null,
            color: isDisabled
                ? "#ccc"
                : isSelected
                ? chroma.contrast(color, "white") > 2
                    ? "white"
                    : "black"
                : data.color,
            cursor: isDisabled ? "not-allowed" : "pointer"
        };
    },
    multiValue: (styles, { data }) => {
        const color = chroma(data.color);
        return {
            ...styles,
            backgroundColor: color.alpha(0.1).css()
        };
    },
    multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: data.color
    }),
    multiValueRemove: (styles, { data }) => ({
        ...styles,
        color: chroma(data.color),
        ":hover": {
            backgroundColor: data.color,
            color: "white"
        }
    })
};

const styleMulti = {
    control: (styles) => ({
        ...styles,
        backgroundColor: "#f4f7fa !important",
        padding: "10px important",
        minHeight: 43,
        borderRadius: 0,
        boxShadow: "none",
        outline: "none"
    })
};

const BCMultiSelectField = ({
    as,
    md,
    isColor,
    controlId,
    value,
    label,
    isMulti,
    isClearable,
    closeMenuOnSelect,
    error,
    options,
    ...props
}) => {
    const [field, meta] = useField(props);
    const { setFieldValue, setFieldTouched } = useFormikContext();
    /**
     * Will manually set the value belong to the name props in the Formik form using setField
     */

    function handleOptionChange(selection) {
        setFieldValue(props.name, selection);
    }

    /**
     * Manually updated the touched property for the field in Formik
     */
    function updateBlur() {
        setFieldTouched(props.name, true);
    }

    // const selectedValue = (options,value) => {
    //     return options ? options.find(option=>option.value === value):""
    // }

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Select
                {...field}
                {...props}
                onBlur={updateBlur}
                onChange={handleOptionChange}
                isMulti={isMulti}
                options={options}
                closeMenuOnSelect={closeMenuOnSelect}
                isSearchable
                isClearable={isClearable}
                components={makeAnimated()}
                styles={isColor ? colourStylesMulti : styleMulti}
                className="basic-multi-select"
                classNamePrefix="react-select"
                // theme={customTheme}
                theme={(theme) => ({
                    ...theme,
                    // borderRadius: 0,
                    borderWidth: 0,
                    colors: {
                        ...theme.colors,
                        //   primary25: 'hotpink',
                        //   primary: meta.error&&meta.touched ? "red" : "green",
                        primary: "green"
                    }
                })}
                placeholder={meta.touched && meta.error ? "Please choose atleast one option" : null}
                // noOptionsMessage={()=>"No option available"}
                // components={{ customInput }}
            />
            {meta.touched && meta.error ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
            {!!error ? <small className="text-danger">{error}</small> : null}
        </Form.Group>
    );
};

BCMultiSelectField.defaultProps = {
    as: Col,
    md: 6,
    isColor: false,
    isMulti: true,
    closeMenuOnSelect: false,
    isClearable: true,
    error: ""
};

export default BCMultiSelectField;
